export const addressTypes = {
  DISPLAY_ADDRESSES: "DISPLAY_ADDRESSES",
  SET_SHOW_ADDRESS_MODAL: "SET_SHOW_ADDRESS_MODAL",
  SET_ADDRESS_DETAILS: "SET_ADDRESS_DETAILS",
  SET_DUMMY_ADDRESS: "SET_DUMMY_ADDRESS",
  RESET_ADDRESS_DETAILS: "RESET_ADDRESS_DETAILS",
  ADD_TO_ADDRESS: "ADD_TO_ADDRESS",
  EDIT_ADDRESS: "EDIT_ADDRESS",
  REMOVE_ADDRESS: "REMOVE_ADDRESS",
  SELECT_ADDRESS_CHECKOUT: "SELECT_ADDRESS_CHECKOUT",
};
